(function (global) {
  var SWATCHES = {
  "grey": "#8a8073",
  "gold": "#b5934e",
  "green": "#6e7c54",
  "blue": "#5a7585",
  "beige": "#c0a588",
  "brown": "#8a5a3e",
  "violet": "#7d6e8a",
  "rose": "#a87e80",
  "red": "#9a4a4a",
  "ochre": "#b5934e",
  "purple": "#6b5b7a",
  "pink": "#c49090",
  "yellow": "#c9a84c",
  "orange": "#c4784a"
};

  var COLOR_PARENT = {
  "brown": "brown",
  "beige": "beige",
  "olive green": "green",
  "blue": "blue",
  "grey": "grey",
  "dark warm grey": "grey",
  "tirquize": "blue",
  "ochre": "ochre",
  "green": "green",
  "red": "red",
  "dark grey": "grey",
  "cold grey": "grey",
  "rose": "rose",
  "warm grey": "grey",
  "grey green": "grey",
  "purple": "purple",
  "light grey": "grey",
  "greenish grey": "grey",
  "yellow": "yellow",
  "grey rose": "grey",
  "violet": "violet",
  "green grey": "grey",
  "orange": "orange",
  "light green": "green",
  "gold": "gold",
  "pink": "pink",
  "dark red": "red",
  "red grey": "grey",
  "light beige": "beige",
  "dark green": "green",
  "light blue": "blue",
  "grey warm": "grey",
  "brown red": "brown",
  "light warm grey": "grey",
  "dark blue": "blue",
  "dark brown": "brown",
  "brown ochre": "brown",
  "brown grey": "grey",
  "green ochre": "ochre",
  "light cold grey": "grey",
  "dark cold grey": "grey",
  "grey red": "grey",
  "green blue ochre": "green",
  "tirquize grey": "blue",
  "brown blue": "blue",
  "ochre red": "ochre",
  "blue green": "green",
  "grey brown": "grey",
  "green brown": "green",
  "blue red": "red",
  "dark green grey": "grey",
  "beige brown": "beige",
  "red ochre": "ochre",
  "red brown": "brown",
  "brown green": "green",
  "light ochre": "ochre",
  "ochre grey": "grey",
  "red blue": "red",
  "blue grey": "grey",
  "ochre green": "ochre",
  "grey ochre": "grey",
  "pink grey": "grey",
  "red orange": "red",
  "ochre brown": "ochre",
  "beige ocher": "beige",
  "ochre blue": "ochre",
  "warm cold grey contrasty": "grey",
  "cold brown": "brown",
  "cold brown grey": "grey",
  "olive grey": "grey",
  "grey rusty": "grey",
  "greenish warm grey": "grey",
  "grey purple": "grey",
  "cold grey rusty": "grey"
};

  var COLORS = [
  {
    "label": "Grey",
    "key": "grey"
  },
  {
    "label": "Green",
    "key": "green"
  },
  {
    "label": "Brown",
    "key": "brown"
  },
  {
    "label": "Blue",
    "key": "blue"
  },
  {
    "label": "Beige",
    "key": "beige"
  },
  {
    "label": "Ochre",
    "key": "ochre"
  },
  {
    "label": "Red",
    "key": "red"
  },
  {
    "label": "Rose",
    "key": "rose"
  },
  {
    "label": "Purple",
    "key": "purple"
  },
  {
    "label": "Violet",
    "key": "violet"
  },
  {
    "label": "Pink",
    "key": "pink"
  },
  {
    "label": "Gold",
    "key": "gold"
  },
  {
    "label": "Yellow",
    "key": "yellow"
  },
  {
    "label": "Orange",
    "key": "orange"
  }
];

  var TEXTURES = [
  {
    "label": "Mid",
    "key": "Mid"
  },
  {
    "label": "Low",
    "key": "Low"
  },
  {
    "label": "Strong",
    "key": "Strong"
  },
  {
    "label": "Distressed",
    "key": "Distressed"
  },
  {
    "label": "Strong contrasty",
    "key": "Strong contrasty"
  },
  {
    "label": "Mid low",
    "key": "Mid low"
  }
];

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function parentColor(key) {
    var k = String(key || '').toLowerCase();
    if (!k) return '';
    return COLOR_PARENT[k] || k;
  }

  function colorMatchesFilter(productColor, filterColor) {
    if (!filterColor || filterColor === 'all') return true;
    return parentColor(productColor) === filterColor;
  }

  function swatchFor(key) {
    return SWATCHES[String(key || '').toLowerCase()] || '';
  }

  function chipHtml(opts) {
    var chipClass = opts.chipClass || 'gravity-shop__chip';
    if (opts.extraClass) chipClass += ' ' + opts.extraClass;
    var sw = opts.swatch
      ? '<span class="' + (opts.swatchClass || 'gravity-shop__chip-swatch') + '" style="background:' + esc(opts.swatch) + '"></span>'
      : '';
    return (
      '<button type="button" class="' + chipClass + '"' +
      ' data-filter-key="' + esc(opts.filterKey) + '"' +
      ' data-filter-val="' + esc(opts.filterVal) + '"' +
      ' aria-pressed="' + (opts.pressed ? 'true' : 'false') + '"' +
      (opts.disabled ? ' disabled aria-disabled="true"' : '') +
      '>' +
      sw +
      esc(opts.label) +
      '</button>'
    );
  }

  function renderChipRow(row, filterKey, options, stateVal, settings) {
    if (!row) return;
    settings = settings || {};
    var chipClass = settings.chipClass || 'gravity-shop__chip';
    var swatchClass = settings.swatchClass || 'gravity-shop__chip-swatch';
    var label = row.querySelector('.gravity-shop__filter-label, .pkg-picker__filter-label');
    var allBtn = row.querySelector('[data-filter-val="all"]');
    row.querySelectorAll('[data-filter-key="' + filterKey + '"]:not([data-filter-val="all"])').forEach(function (el) {
      el.remove();
    });
    var frag = document.createDocumentFragment();
    options.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = chipClass + (settings.lockedClass && settings.locked ? ' ' + settings.lockedClass : '');
      btn.setAttribute('data-filter-key', filterKey);
      btn.setAttribute('data-filter-val', opt.key);
      btn.setAttribute('aria-pressed', stateVal === opt.key ? 'true' : 'false');
      if (settings.locked) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      }
      if (filterKey === 'color') {
        var sw = swatchFor(opt.key);
        if (sw) {
          var span = document.createElement('span');
          span.className = swatchClass;
          span.style.background = sw;
          btn.appendChild(span);
        }
      }
      btn.appendChild(document.createTextNode(opt.label));
      frag.appendChild(btn);
    });
    if (allBtn && allBtn.nextSibling) {
      row.insertBefore(frag, allBtn.nextSibling);
    } else {
      row.appendChild(frag);
    }
    if (label && label !== row.firstElementChild) {
      row.insertBefore(label, row.firstChild);
    }
  }

  global.GRAVITY_FILTER_OPTIONS = {
    colors: COLORS,
    textures: TEXTURES,
    colorParent: COLOR_PARENT,
    parentColor: parentColor,
    colorMatchesFilter: colorMatchesFilter,
    swatchFor: swatchFor,
    renderChipRow: renderChipRow,
    chipHtml: chipHtml,
  };
})(typeof window !== 'undefined' ? window : this);
